import messages from "./en-US.json";

export const defaultMessages = messages;
